import axios from "axios";
import { buildApiUrl } from "../config/api";

export async function fetchAcademicYears(schoolId) {
    const { data } = await axios.get(buildApiUrl(`/AcademicPeriod/${schoolId}/years`));
    return data;
}

export async function fetchCurrentPeriod(schoolId) {
    const { data } = await axios.get(buildApiUrl(`/AcademicPeriod/${schoolId}/current`));
    return data;
}

export async function fetchStaffAcademicCalendar(schoolId, { educationLevel, academicYear } = {}) {
    const params = new URLSearchParams();
    if (educationLevel) params.set("educationLevel", educationLevel);
    if (academicYear) params.set("academicYear", academicYear);
    const qs = params.toString();
    const { data } = await axios.get(
        buildApiUrl(`/AcademicPeriod/${schoolId}/staff-calendar${qs ? `?${qs}` : ""}`)
    );
    return data;
}

export async function createAcademicYear(schoolId, payload) {
    const { data } = await axios.post(buildApiUrl(`/AcademicPeriod/${schoolId}/year`), payload);
    return data;
}

export async function saveTermBatch(schoolId, payload) {
    const { data } = await axios.post(buildApiUrl(`/AcademicPeriod/${schoolId}/terms`), payload);
    return data;
}

export async function updateTerm(termId, payload) {
    const { data } = await axios.put(buildApiUrl(`/AcademicPeriod/term/${termId}`), payload);
    return data;
}

export async function updateTermStatus(termId, status) {
    const { data } = await axios.put(buildApiUrl(`/AcademicPeriod/term/${termId}/status`), { status });
    return data;
}

export async function setCurrentPeriod(schoolId, { academicYearId, schoolTermId }) {
    const { data } = await axios.put(buildApiUrl(`/AcademicPeriod/${schoolId}/current`), {
        academicYearId,
        schoolTermId,
    });
    return data;
}

export async function syncFromCalendarNotices(schoolId) {
    const { data } = await axios.post(buildApiUrl(`/AcademicPeriod/${schoolId}/sync-calendar`));
    return data;
}
